import { render } from "./Evolucion.vue?vue&type=template&id=48cbccea&scoped=true"
import script from "./Evolucion.vue?vue&type=script&lang=js"
export * from "./Evolucion.vue?vue&type=script&lang=js"

import "./Evolucion.vue?vue&type=style&index=0&id=48cbccea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48cbccea"]])

export default __exports__